import Column from '@components/Column';
import Header from '@components/Header';
import styled from '@emotion/styled';
import type { RegisteredActivityName } from '@stackflow/config';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import AppleSignInButton from './components/AppleSignInButton';
import GoogleSignInButton from './components/GoogleSignInButton';
import KakaoSignInButton from './components/KakaoSignInButton';
import PhoneSignInButton from './components/PhoneSignInButton';
import SignInTop from './components/SignInTop';
import SignUpText from './components/SignUpText';
import useAuthFlow from './hooks/useAuthFlow';

interface Params {
    flows?: {
        activityName: RegisteredActivityName,
        activityParams: object,
    }[]
}

declare module '@stackflow/config' {
    interface Register {
        SignInActivity: Params;
    }
}

const SignInActivity: ActivityComponentType<'SignInActivity'> = ({ params }) => {
    const { flows } = params;
    useAuthFlow(flows);
    const lastLoginMethod = window.localStorage.getItem('lastLoginMethod');
    return (
        <AppScreen>
            <Column fullHeight>
                <Header title='' />
                <Container fullWidth fullHeight align='center' justify='space-between'>
                    <SignInTop/>
                    <ButtonContainer fullWidth spacing={4}>
                        <Column fullWidth spacing={2}>
                            <AppleSignInButton isLastLogin={lastLoginMethod === 'APPLE'}/>
                            <KakaoSignInButton isLastLogin={lastLoginMethod === 'KAKAO'} />
                            <GoogleSignInButton isLastLogin={lastLoginMethod === 'GOOGLE'} />
                            <PhoneSignInButton isLastLogin={lastLoginMethod === 'PHONE'}/>
                        </Column>
                        <SignUpText/>
                    </ButtonContainer>
                </Container>
            </Column>
        </AppScreen>
    );
};

const Container = styled(Column)`
    flex: 1;
    height: 100vh;
    padding: var(--spacing-16) 0 calc(var(--spacing-4) + var(--safe-area-bottom));

    @media (max-height: 700px) {
        padding: var(--spacing-4) 0 var(--spacing-5);
    }
`;

const ButtonContainer = styled(Column)`
    padding: 0 var(--spacing-4);
    position: relative;
`;

export default SignInActivity;
